import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

document.addEventListener("DOMContentLoaded", () => {
  const swiper = new Swiper(".mySwiper", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1.7, // 同時顯示 1.7 個滑塊
    spaceBetween: 30, // 每個滑塊間距
    loop: true, // 啟用循環模式
    autoplay: {
      delay: 3000, // 自動輪播間隔時間（毫秒）
      disableOnInteraction: false, // 用戶操作後不停止自動輪播
    },
    navigation: {
      nextEl: ".swiper-button-next", // 下一張按鈕
      prevEl: ".swiper-button-prev", // 上一張按鈕
    },
    pagination: {
      el: ".swiper-pagination", // 分頁指示器
      clickable: true, // 分頁可點擊
    },
    breakpoints: {
      640: {
        slidesPerView: 3.5, // 在寬度 >= 640px 時顯示 1.5 個滑塊
      },
      1024: {
        slidesPerView: 4.5, // 在寬度 >= 640px 時顯示 1.5 個滑塊
      },
    },
  });
});
